var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "b5decd459facc9b5dbb3e264aa4d6efeea55a4ff"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["www-ligonier-org@ligonier"] = {
  id: "b5decd459facc9b5dbb3e264aa4d6efeea55a4ff"
};